import { IKnowledgeBase } from "../../../../commons/interfaces/knowledge-base.interface";

export const mapKnowledgeBaseToFrontend = (data: any): IKnowledgeBase => {
    return {
        id: data?.id || '',
        name: data?.name || '',
        description: data?.description || '',
        originalName: data?.originalName || '',
        fileName: data?.fileName || '',
        extension: data?.extension || '',
        mimeType: data?.mimeType || '',
        size: data?.size || 0,
        path: data?.path || '',
        embeddingProvider: data?.embeddingProvider || '',
        embeddingModel: data?.embeddingModel || '',
        embeddingStatus: data?.embeddingStatus || '',
        chunks: data?.chunks || 0,
        vectorCount: data?.vectorCount || 0,
        isActive: data?.isActive !== undefined ? data.isActive : true,
        metadata: data?.metadata || {},
        createdAt: data?.createdAt || '',
        updatedAt: data?.updatedAt || ''
    }
}

export const mapKnowledgeBaseToBackend = (data: IKnowledgeBase): any => {
    return {
        name: data?.name,
        description: data?.description,
        originalName: data?.originalName,
        fileName: data?.fileName,
        extension: data?.extension,
        mimeType: data?.mimeType,
        size: data?.size,
        path: data?.path,
        embeddingProvider: data?.embeddingProvider,
        embeddingModel: data?.embeddingModel,
        embeddingStatus: data?.embeddingStatus,
        chunks: data?.chunks,
        vectorCount: data?.vectorCount,
        isActive: data?.isActive,
        metadata: data?.metadata
    }
}
